import { NullOrMissingField1bkks6typ2v8h as NullOrMissingField } from '../exception/Exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function missingField(jsonReader, name) {
  throw NullOrMissingField().e45("Field '" + name + "' is missing or null at path " + toString(jsonReader.h2s()));
}
//region block: exports
export {
  missingField as missingField4n9ldh7pi82p,
};
//endregion

//# sourceMappingURL=Assertions.mjs.map
